import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=359e3c50"
import script from "./SelectType.vue?vue&type=script&lang=js"
export * from "./SelectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359e3c50')) {
      api.createRecord('359e3c50', component.options)
    } else {
      api.reload('359e3c50', component.options)
    }
    module.hot.accept("./SelectType.vue?vue&type=template&id=359e3c50", function () {
      api.rerender('359e3c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/management/ticket/pages/type/SelectType.vue"
export default component.exports